/** Blue "Popular" pill used on OTC nav links, cards, and page headers. */
export default function PopularBadge({ className = "", testId = "otc-popular-badge" }) {
  return (
    <span
      className={`inline-block text-[7px] font-extrabold uppercase tracking-[0.12em] px-1.5 py-[3px] rounded-[4px] leading-none text-white shrink-0 ${className}`}
      style={{
        background: "linear-gradient(135deg, #4F7CFF 0%, #022CEE 55%, #0219A8 100%)",
        boxShadow:
          "0 0 10px rgba(2, 44, 238, 0.35), 0 1px 4px rgba(2, 44, 238, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
      }}
      data-testid={testId}
    >
      Popular
    </span>
  );
}
